module.exports = __webpack_public_path__ + "img/HSV21 Holzbach Bild 8.2f727a10.jpg";